export default __webpack_public_path__ + "static/media/landing.af17a204.jpg";